import React, { useState } from "react";
import Modal from "antd/lib/modal";
import "antd/lib/modal/style";
import Spin from "antd/lib/spin";
import "antd/lib/spin/style";
import GooglePlus from "@/assets/icons/circleColor_googleplus.svg";
import FacebookPlus from "@/assets/icons/circleColor_facebook.svg";
import LinkedinPlus from "@/assets/icons/circleColor_linkedin.svg";
import "./styles.less";
import AuthHelpers from "@/services/auth/helpers";
import ServiceDirectoryService from "@/services/service-directory";
import env from "@/env";
import { detectWebApp } from "@/utils";
import * as firebase from "firebase/app";
import "firebase/auth";
import { useDispatch } from "react-redux";
import { fetchAssetSocialActions } from "@/redux/actions/service-directory";

firebase.initializeApp({
  apiKey: env.socials.firebaseApiKey,
  authDomain: env.socials.firebaseAuthDomain,
});
interface SocialPopupProps {
  active: boolean;
  toggleModal: any;
}

const SocialPopup: React.FC<SocialPopupProps> = ({ active, toggleModal }) => {
  const webApp = detectWebApp[env.siteId as keyof typeof detectWebApp];
  const [loginValidate, setLoginValidate] = useState<boolean>(true);
  const [spin, setSpin] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    toggleModal && toggleModal();
  };

  const handleLoginLinkedin = async () => {
    const clientIdLinkedin = env.socials.linkedinClientId;
    const callBackUrl = `${env.rootUrl}/${env.socials.linkedinCallBack}`;
    const url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientIdLinkedin}&redirect_uri=${callBackUrl}&state=openPanking&scope=r_liteprofile%20r_emailaddress`;
    AuthHelpers.storeLinkedInCallback(window.location.href);
    window.location.href = url;
  };

  const handleLoginFirebase = (socialNetwork: string) => {
    let provider: any = {};
    // eslint-disable-next-line default-case
    switch (socialNetwork) {
      case "google": {
        provider = new firebase.auth.GoogleAuthProvider();
        break;
      }
      case "facebook": {
        provider = new firebase.auth.FacebookAuthProvider();
        break;
      }
    }
    // firebase.auth().useDeviceLanguage();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async (result: any) => {
        const token = result.credential.accessToken;
        setLoginValidate(true);
        try {
          setSpin(true);
          const {
            socialUserToken,
          } = await ServiceDirectoryService.exchangeSocialToken(
            token,
            socialNetwork
          );
          setSpin(false);
          if (socialUserToken) {
            dispatch(fetchAssetSocialActions.request(socialUserToken));
            AuthHelpers.storeSocialToken(socialUserToken);
            toggleModal();
          }
        } catch (error) {
          setLoginValidate(false);
          setSpin(false);
        }
      });
  };

  return (
    <Modal
      className="social-popup"
      visible={active}
      title="Title"
      footer={null}
      onCancel={handleClose}
      closable
    >
      <Spin spinning={spin}>
        <div className="popup-content-header">
          <img className="image-logo" src={webApp?.logo} alt="BankApiLogo" />
          <div className="modal-title">
            <p>Sign in to Join the </p>
            <p>{webApp?.appName} Community</p>
          </div>
          <button className="popup-close" onClick={() => handleClose()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6 6l6 6m0 0l6-6m-6 6l-6 6m6-6l6 6"
              />
            </svg>
          </button>
        </div>
        <div className="popup-content-button">
          {!loginValidate && (
            <div className="error-login">
              An error occurred. login unsuccessful
            </div>
          )}
          <div
            className="button-login"
            onClick={() => handleLoginFirebase("google")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleLoginFirebase("google");
              }
            }}
          >
            <img
              className="image-logo"
              src={GooglePlus}
              alt="Icon Google Plus"
            />
            <button type="button" className="button-login-google">
              <span>Sign in with Google</span>
            </button>
          </div>
          <div
            className="button-login google"
            onClick={() => handleLoginFirebase("facebook")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleLoginFirebase("facebook");
              }
            }}
          >
            <img
              className="image-logo"
              src={FacebookPlus}
              alt="Icon Google Plus"
            />
            <button type="button" className="button-login-google">
              <span>Sign in with Facebook</span>
            </button>
          </div>
          <div
            className="button-login"
            onClick={() => handleLoginLinkedin()}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleLoginLinkedin();
              }
            }}
          >
            <img
              className="image-logo"
              src={LinkedinPlus}
              alt="Icon Linkedin Plus"
            />
            <div className="button-login-linkedin">Sign in with LinkedIn</div>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default SocialPopup;
